import React, { useState, useEffect } from 'react';
import translate from '../../../../utilities/translator';
import { IMAGE_CDN } from '../../../../constants/constants';
import SearchResultItem from '../../../../components/search/SearchResultItem';
import { pushEvent } from '../../../../utilities/analytics';
import { WHERE_FILTER_DESTINATION_NO_MATCH } from '../../../../constants/analyticEvents';

let noresTime; // timeout for no match event

const SearchList = ({
  destinations,
  destinationsGroups,
  searchValue,
  setSearchValue,
  setDestinations,
  setDestinationsGroups,
  handleCheckboxChange,
  autocompleteCities = [], // TODO: Remove autocompleteCities logic
}) => {
  const [autocompleteCitySelected, setAutocompleteCitySelected] = useState({
    selected: false,
    value: '',
  });

  useEffect(() => {
    setAutocompleteCitySelected({ selected: false, value: '' });
    clearTimeout(noresTime);
    if (foundDestinations.length === 0 && foundDestinationsGroup.length === 0 && autocompleteCities.length === 0 && searchValue) {
      const _searchValue = searchValue;
      noresTime = setTimeout(() => {
        pushEvent(WHERE_FILTER_DESTINATION_NO_MATCH, { searchPhrase: _searchValue });
      }, 2000);
    }
  }, [searchValue]);

  const getCountry = (str) => {
    if (!str) return '';

    const arr = str.split(',');
    return arr[arr.length - 1];
  };

  const wrapSearch = (str) => {
    let result = str;

    searchValue.split(/[ ,]/gi).forEach((value) => {
      const regex = new RegExp(value, "gi");

      if (regex.test(str) && value.length > 1) {
        const searchPosition = result.toLowerCase().indexOf(value.toLowerCase());

        result = `${result.slice(0, searchPosition)}<b>${result.slice(
          searchPosition,
          searchPosition + value.length
        )}</b>${result.slice(searchPosition + value.length)}`
      }
    });

    return result;
  };

  const inSearch = (str) =>
    str.toLowerCase().includes(searchValue.toLowerCase());

  const inSearchAlias = (alias) => {
    // search in the name_alias array
    const aliasNames = Object.values(alias).filter(name => (name.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1));
    return aliasNames.length > 0;
  };

  const foundDestinations = destinations
    .filter((item) => inSearch(item.name) || inSearchAlias(item.name_alias) || inSearch(getCountry(item.atlas_top)))
    .map((item) => ({
      ...item,
      name: (inSearch(item.name) || inSearchAlias(item.name_alias)) ? wrapSearch(item.name) : item.name,
      atlas_top: inSearch(getCountry(item.atlas_top))
        ? wrapSearch(getCountry(item.atlas_top))
        : getCountry(item.atlas_top),
    }));

  const foundDestinationsGroup = destinationsGroups
    .filter((item) => inSearch(item.name))
    .map((item) => ({
      ...item,
      name: wrapSearch(item.name),
    }));

  const handleClick = (id, array, setArray, active, isGroup) => () => {
    setSearchValue('');
    if (active) return;

    handleCheckboxChange(id, array, setArray,isGroup);
  };

  const handleAutocompleteCityClick = (city) => () => {
    setAutocompleteCitySelected({ selected: true, value: city });
  };

  const renderDestinationsGroup = () => (
    foundDestinationsGroup.map(({ id, name, active }) => (
      <SearchResultItem
        key={id}
        type="group"
        title={name}
        onClick={handleClick(
          id,
          destinationsGroups,
          setDestinationsGroups,
          active,
          true
        )}
      />
    ))
  );

  const renderDestinations = () => (
    foundDestinations.map(({ id, name, atlas_top, active }) => (
      <SearchResultItem
        key={id}
        type="destination"
        title={name}
        subtitle={atlas_top}
        onClick={handleClick(id, destinations, setDestinations, active)}
      />
    ))
  )

  const renderAutocompleteCities = () => (
    autocompleteCities.map((city) => (
      <SearchResultItem
        key={city.value}
        type="city"
        title={city.label}
        subtitle={city.label}
        onClick={handleAutocompleteCityClick(city.label)}
      />
    ))
  )

  const renderAutocompleteCitySelected = () => (
    <div className="search-list__warning">
      <img
        src={`${IMAGE_CDN}/search-list.svg`}
        alt={translate("holidayFinder.recentSearch.noRecentSearches")}
      />
      <p>
        {translate("holidayFinder.searchList.sorry")}{" "}
        {autocompleteCitySelected.value}
      </p>
      <p>{translate("holidayFinder.searchList.checkBack")}</p>
    </div>
  )

  return (
    <div className="search-list">
      {renderDestinationsGroup()}
      {renderDestinations()}
      {
        !autocompleteCitySelected.selected &&
        foundDestinations.length === 0 &&
        foundDestinationsGroup.length === 0 &&
        autocompleteCities.length !== 0 &&
        renderAutocompleteCities()
      }
      {autocompleteCitySelected.selected && (
        renderAutocompleteCitySelected()
      )}
      {foundDestinations.length === 0 &&
        foundDestinationsGroup.length === 0 &&
        autocompleteCities.length === 0 && (
          <div className="search-list__no-matches">{translate('holidayFinder.destinations.searchNoResults')}</div>
        )
      }
    </div>
  );
};

export default SearchList;
